import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const PiggyBank = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M7.44 7.437C8.816 6.222 10.976 5.547 13.145 6m-5.06 14.1q-.267 0-.527-.008c-.74-.018-1.246-.397-1.464-1.097l-.306-.99a170 170 0 0 0-.682-2.18.9.9 0 0 0-.173-.304c-.716-.814-1.21-1.72-1.473-2.693a1.68 1.68 0 0 1-1.445-1.435 1.71 1.71 0 0 1 1.111-1.834c.078-.03.19-.07.325-.09.45-1.68 1.485-3.058 3.076-4.1 1.587-1.039 3.418-1.528 5.45-1.449a9.4 9.4 0 0 1 3.926 1.04 5 5 0 0 1 2.41-.445c.78.046 1.135.479 1.297.834.297.656-.053 1.176-.222 1.426-.174.257-.343.54-.514.857q.443.571.935 1.15c.043.003.107.001.17 0a3 3 0 0 1 .25 0c.99.04 1.749.802 1.765 1.773q.006.391.003.782l-.001.34-.002.29c-.002.198-.004.397.003.595.028.77-.277 1.423-.908 1.943-1.07.88-2.151 1.556-3.306 2.064a.4.4 0 0 0-.056.029l-.009.03c-.175.61-.367 1.22-.554 1.81l-.17.544c-.226.722-.725 1.096-1.484 1.111-.387.008-.73.008-1.048-.002-.72-.021-1.23-.409-1.438-1.092l-.057-.185q-.087-.279-.171-.567a10 10 0 0 1-2.492 0q-.098.337-.2.676l-.014.047c-.214.716-.728 1.105-1.484 1.123a23 23 0 0 1-.52.006m9.06-10.6a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(PiggyBank) as SvgIcon;
export { ForwardRef as ReactComponent };
